import { atom, useRecoilCallback } from 'recoil'

import {
  CertNumState,
  SecurityNumState,
  TelNumState,
  TimeOutState,
  TranIdState,
} from '@/shared/store'

const RefundTypeState = atom({
  //bankName
  key: 'RefundTypeState',
  default: 'none',
})
const RefundName = atom({
  key: 'RefundName',
  default: [
    {
      state: '',
      check: false,
    },
  ],
})
const RefundAccount = atom({
  key: 'RefundAccount',
  default: [
    {
      state: '',
      check: false,
    },
  ],
})
const RefundTermYN = atom({
  key: 'RefundTermYN',
  default: false,
})

export const useRefundResetCallback = () => {
  return useRecoilCallback(
    ({ reset }) =>
      () => {
        reset(TelNumState)
        reset(CertNumState)
        reset(RefundName)
        reset(RefundAccount)
        reset(RefundTypeState)
        reset(RefundTermYN)
        reset(TimeOutState)
        reset(TranIdState)
        reset(SecurityNumState)
      },
    [],
  )
}

export { RefundAccount, RefundName, RefundTermYN, RefundTypeState }
